import ToutSmall from './ToutSmall'

export default ToutSmall
